module.exports = __webpack_public_path__ + "img/mortgageSwissLifeBanner.cb912e6.jpg";